<!-- Start Navbar -->
<nav class='navbar navbar-expand-lg'>
  <div class='container'>
    <a class='navbar-brand' routerLink='vue-en'>
      <img src='../../assets/images/logo.svg' alt='' class='img-fluid'>
    </a>
    <a href='tel:+201001040090' dir='ltr' class='btn tel d-lg-none d-block'>01001040090</a>
    <button class='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarSupportedContent'
      aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
      <i class='fas fa-bars'></i>
    </button>
    <div class='collapse navbar-collapse' id='navbarSupportedContent'>
      <ul class='navbar-nav ml-auto mb-2 mb-lg-0'>
        <li class='nav-item'>
          <a class='nav-link active' aria-current='page' routerLink='/'>Home</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' routerLink='/allegria-en'>allegria</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' routerLink='/estate-en'>ESTATE</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' routerLink='/vye-en'>VYE</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' routerLink='/eastvale-en'>Eastvale</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' (click)='scrollTo(contact)'>Contact Us</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' href='tel:+201001040090'>
            <svg xmlns='http://www.w3.org/2000/svg' width='20.534' height='20.581' viewBox='0 0 20.534 20.581'>
              <path id='Path_41' data-name='Path 41'
                d='M33.868,37.277a12.819,12.819,0,0,1,3.222-4.043.677.677,0,0,1,.9-.075c.375.374,3.446,3.893,3.446,3.893a.743.743,0,0,1-.075.973c-.524.524-2.173,2.1-2.173,2.1a.87.87,0,0,0,.075.973,28.192,28.192,0,0,0,6.368,6.289.852.852,0,0,0,.9.15s1.648-1.722,2.1-2.171a.7.7,0,0,1,.974-.15s3.521,3.07,3.9,3.519a.676.676,0,0,1-.075.9c-1.049,1.048-2.622,2.7-4.046,3.22C44.807,54.573,32.07,41.845,33.868,37.277Zm18.58,11.83c-.45-.449-1.049-.973-1.5-1.348-.6-.524-1.2-1.048-1.723-1.5-.674.6-1.274,1.273-1.948,1.947a1.805,1.805,0,0,1-2.248.075A30.556,30.556,0,0,1,38.439,41.7a1.935,1.935,0,0,1-.15-2.1l.15-.225c.674-.6,1.349-1.273,2.023-1.872-.9-1.048-1.948-2.321-2.922-3.294l-.45.449a11.468,11.468,0,0,0-2.323,2.995c-.375,1.048.524,2.845.974,3.744a29.162,29.162,0,0,0,4.2,5.316A25.719,25.719,0,0,0,45.256,50.9c.9.524,2.772,1.348,3.821.973a12.42,12.42,0,0,0,3-2.321C52.224,49.407,52.3,49.257,52.449,49.108Z'
                transform='translate(-33.396 -32.728)' fill='#31aade' stroke='#31aade' stroke-width='0.5'
                fill-rule='evenodd' />
            </svg>
            <span>+201001040090</span>
          </a>
        </li>
        <li class='nav-item'>
          <a class='nav-link btn btn-language' routerLink='/eastvale-ar'>عربي</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<main dir='ltr' style='text-align: left'>
  <!-- Start Header -->
  <section class='header'>
    <div class='text'>
      <h5>Eastvale</h5>
      <h2>Modern Future Community</h2>
      <h5>A forward-thinking destination envisioned by top international architects, offering a balanced blend of
        luxury, innovation, and sustainability. Live in a space where design and comfort redefine modern living.</h5>
    </div>
    <div class='slider-con'>
      <owl-carousel-o [options]='customOptions'>
        @for (slide of slidesStore; track slide) {
        <ng-template carouselSlide>
          <div class='img-con'>
            <div class='card-img-overlay'></div>
            <div class='img' [ngStyle]="{backgroundImage: 'url(./images/' + slide.src + ')'}"></div>
          </div>
        </ng-template>
        }
      </owl-carousel-o>
    </div>
    <button class='btn'>Join Us</button>
  </section>
  <!-- Start Development -->
  <section class='development'>
    <div class='container'>
      <div class='row'>
        <div class='col-md-9 mx-auto'>
          <div class='text-con text-center'>
            <h2 class="text-white mt-0 mb-3">Eastvale</h2>
            <h3>Experience More, Live Eastvale</h3>
            <p>Eastvale introduces a new lifestyle concept — a seamlessly connected community where living,
              learning, working, shopping, and leisure come together. Enjoy a walkable environment designed for your
              comfort and well-being.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Start Master Plan -->
  <section class='master-plan'>
    <div class='text-con'>
      <div class='container'>
        <h2>LIVE LIMITLESS</h2>
        <p>Discover modern living at Eastvale in MADA City, where stylish homes and cutting-edge amenities come together
          to create a vibrant and connected community.</p>
      </div>
    </div>
  </section>
  <!-- Start Video Slider -->
  <section #project class='images-con'>
    <div class='container'>
      <div class='row'>
        <div class='col-md-5' style='margin-bottom: 30px;'>
          <div class='img-con object-fit-contain' style='background-image: url(assets/images/slider1-mada.png);'></div>
        </div>
        <div class='col-md-7' style='margin-bottom: 30px;'>
          <div class='img-con object-fit-contain' style='background-image: url(assets/images/slider2-mada.png);'></div>
        </div>
        <div class='col-md-7' style='margin-bottom: 30px;'>
          <div class='img-con object-fit-contain' style='background-image: url(assets/images/slider3-mada.png);'>
          </div>
        </div>
        <div class='col-md-5' style='margin-bottom: 30px;'>
          <div class='img-con object-fit-contain' style='background-image: url(assets/images/slider4-mada.png);'></div>
        </div>
        <div class='col-md-5' style='margin-bottom: 30px;'>
          <div class='img-con object-fit-contain' style='background-image: url(assets/images/slider5-mada.png);'></div>
        </div>
        <div class='col-md-7'>
          <div class='img-con object-fit-contain' style='background-image: url(assets/images/slider6-mada.png);'></div>
        </div>
      </div>
    </div>
  </section>
  <!-- Start The Big Slider -->
  <section id='big-slider'>
    <div class='container'>
      <div class='row'>
        <div class='col-md-12'>
          <h2>LAUNCH STARTING PRICES</h2>
          <div class='main-projects mt-4'>
            <!-- Row 1: 3 circles -->
            <div class='row g-4 justify-content-center mb-4'>
              <div class='col-md-4 col-sm-6'>
                <div class='property-circle'>
                  <div class='circle-content'>
                    <h3>TOWNHOUSE</h3>
                    <p class='price'>EGP 27.9 MN</p>
                  </div>
                </div>
              </div>
              <div class='col-md-4 col-sm-6'>
                <div class='property-circle'>
                  <div class='circle-content'>
                    <h3>TWIN VILLA</h3>
                    <p class='price'>EGP 34.5 MN</p>
                  </div>
                </div>
              </div>
              <div class='col-md-4 col-sm-6'>
                <div class='property-circle'>
                  <div class='circle-content'>
                    <h3>URBAN VILLA</h3>
                    <p class='price'>EGP 39.2 MN</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Row 2: 3 circles -->
            <div class='row g-4 justify-content-center'>
              <div class='col-md-4 col-sm-6'>
                <div class='property-circle'>
                  <div class='circle-content'>
                    <h3>SMALL VILLA</h3>
                    <p class='price'>EGP 44.8 MN</p>
                  </div>
                </div>
              </div>
              <div class='col-md-4 col-sm-6'>
                <div class='property-circle'>
                  <div class='circle-content'>
                    <h3>MEDIUM VILLA</h3>
                    <p class='price'>EGP 49.2 MN</p>
                  </div>
                </div>
              </div>
              <div class='col-md-4 col-sm-6'>
                <div class='property-circle'>
                  <div class='circle-content'>
                    <h3>LARGE VILLA</h3>
                    <p class='price'>EGP 55.9 MN</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Start About & Contact -->
  <section class='last-section'>
    <div class='container'>
      <div class='row'>
        <div class='col-md-12'>
          <section #about class='about'>
            <h2>
              about
              <span>universe</span>
            </h2>
            <p>UNIVERSE was founded in 1996, with a fundamental commitment to the concept of ‘Human Developments’at its
              heart. This ethos goes beyond mere bricks
              and mortar. UNIVERSE aims to create environments where residents can lead healthy, productive, creative
              lives, achieving their aspirations and
              thriving both as individuals and as communities. This mindset adds value to our developments and to the
              lives of those that live in them. Our
              projects adopt cutting-edge design and construction techniques and are delivered on time, every time with
              the highest standards of customer
              service. UNIVERSE’s portfolio of world-class, awardwinning developments speaks for itself and assures its
              position at the forefront of the Egyptian
              real estate market.</p>
          </section>
          <!-- Start Contact -->
          <section #contact class='contact'>
            <h2>
              contact
              <span>us</span>
            </h2>
            <div class='row'>
              <div class='col-xxl-4 col-lg-8 col-md-10 mx-auto'>
                <form [formGroup]='updateForm' (ngSubmit)='onSubmit()'>
                  <div class='row'>
                    <div class='col-md-6 mb-4'>
                      <input type='text' placeholder='Full Name' title='Full Name' class='form-control'
                        formControlName='name'>
                      <app-field-error [displayError]="isFieldValid('name')"
                        errorMsg='Please Enter your name'></app-field-error>
                    </div>
                    <div class='col-md-6 mb-4'>
                      <input type='text' placeholder='Email Address' title='Email Address' class='form-control'
                        formControlName='email'>
                      <app-field-error [displayError]="isFieldValid('email')"
                        errorMsg='Please Enter a valid mail'></app-field-error>
                    </div>
                    <div class='col-12 mb-4'>
                      <input type='text' placeholder='Mobile Number' title='Mobile Number' class='form-control'
                        formControlName='phone'>
                      <app-field-error [displayError]="isFieldValid('phone')"
                        errorMsg='Please Enter a valid phone number'></app-field-error>
                    </div>
                    <div class='col-md-12 mb-4'>
                      <textarea name='Message' title='Message' placeholder='Message' class='form-control'
                        formControlName='notes'></textarea>
                      <app-field-error [displayError]="isFieldValid('notes')"
                        errorMsg='message must be more than 20 chars'></app-field-error>
                    </div>
                    <div class='col-12'>
                      <button type='submit' class='btn btn-block' [disabled]='submitted'>send</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</main>
<!-- Start Footer -->
<footer>
  <div class='container'>
    <div class='row'>
      <div class='col-md-auto my-auto'>
        <h6>Contact Us</h6>
        <div class='details'>
          <div>
            <a href='tel:+20102135592'>+20102135592</a>
          </div>
          <div>Sat-Thr 9AM-6PM</div>
        </div>
      </div>
      <div class='col-md mx-auto text-center my-md-auto my-3'>
        <img src='../../assets/images/logo.svg' alt='Logo' class='img-fluid'>
      </div>
      <div class='col-md-auto ml-auto my-auto'>
        <h6>Company</h6>
        <nav>
          <ul class='list-unstyled'>
            <li>
              <a href='#'>Home</a>
            </li>
            <li>
              <a (click)='scrollTo(project)'>Universe Development</a>
            </li>
            <li>
              <a (click)='scrollTo(about)'>About</a>
            </li>
            <li>
              <a (click)='scrollTo(contact)'>Contact Us</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</footer>